var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    opacity: 0.65,
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 5.42281C22.4355 5.82876 21.5192 6.03173 20.6029 6.13321C21.5192 5.5243 22.2319 4.61093 22.6391 3.59607C21.7228 4.1035 20.7048 4.50945 19.6867 4.71242C17.9559 2.88568 15.0034 2.78419 13.1708 4.50945C11.9491 5.62579 11.44 7.24957 11.8473 8.87334C8.18212 8.67036 4.72059 6.9451 2.37897 4.1035C1.15725 6.2347 1.7681 8.87332 3.8043 10.1926C3.09163 10.1926 2.37895 9.98967 1.66628 9.58373C1.66628 9.58373 1.66628 9.58372 1.66628 9.68521C1.66628 11.9179 3.19344 13.7446 5.33145 14.1506C4.61878 14.3536 3.90611 14.3535 3.29525 14.2521C3.90611 16.0788 5.63689 17.3981 7.57128 17.3981C5.94232 18.7174 3.90611 19.3263 1.86992 19.3263C1.46268 19.3263 1.15724 19.3264 0.75 19.2249C6.8586 23.0813 14.9016 21.3561 18.7704 15.2669C20.0939 13.1357 20.8066 10.7001 20.8066 8.26442C20.8066 8.06144 20.8066 7.85847 20.8066 7.6555C21.8247 7.14807 22.6391 6.33619 23.25 5.42281Z",
    fill: "#FFFFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f2c4f69e8086602f53e1d15abbfc20d7.svg";
export { ForwardRef as ReactComponent };